<!-- 组件说明 -->
<template>
  <div class="shoppinglist-container">
    <div>
      <div class="con">
        <div class="shopping-title">
          <h1>商品控销</h1>
          <p>Activity topics</p>
          <i></i>
        </div>
        <div v-if="subjectlist.length">
          <!-- 切换栏 -->
          <div class="list-header">
            <div class="title">
              <i></i>
              <span>控销商品</span>
            </div>
            <div class="listBtn">
              <div
                class="list c-pointer"
                :class="{ active: type == 1 }"
                @click="type = 1"
              >
                <img
                  :src="require('@/assets/images/icon_c1.png')"
                  v-if="type == 2"
                  alt=""
                />
                <img
                  :src="require('@/assets/images/icon_c2.png')"
                  v-else
                  alt=""
                />
                <span>列表</span>
              </div>
              <div
                class="table c-pointer"
                :class="{ active: type == 2 }"
                @click="type = 2"
              >
                <img
                  :src="require('@/assets/images/icon_d1.png')"
                  v-if="type == 1"
                  alt=""
                />
                <img
                  :src="require('@/assets/images/icon_d2.png')"
                  v-else
                  alt=""
                />
                <span>表格</span>
              </div>
            </div>
          </div>
          <!-- 商品列表 -->
          <goodslistceil2
            v-if="type == 1"
            :goodsList="subjectlist"
          ></goodslistceil2>
          <goodslistceil v-else :goodsList="subjectlist"></goodslistceil>
        </div>
        <div class="empty " v-if="subjectlist.length == 0 && loaded">
          <div class="empty-img">
            <img :src="require('../../../assets/images/sousuo.png')" alt="" />
          </div>
          <div class="empty-con">
            <h5>暂无控销商品</h5>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :page-size="pageInfo.pageSize"
        @current-change="getlist"
        :total="total"
        :current-page="pageInfo.pageNumber"
        v-if="subjectlist.length"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import goodslistceil from "@/components/goods-list-ceil";
import goodslistceil2 from "@/components/goods-list-ceil-2";
export default {
  components: { goodslistceil, goodslistceil2 },
  data() {
    return {
      type: 1, //1列表  2表格
      subjectlist: [],
      loaded: true,
      detail: "",
      pageInfo: {
        pageNumber: 1,
        pageSize: 20
      },
      total: 0
    };
  },
  computed: {},
  methods: {
    getlist(pageNumber) {
      this.loaded = false;
      const brandId = this.$route.query.brandId;
      const isControl = this.$route.query.isControl;
      this.pageInfo.pageNumber = pageNumber;
      this.$api
        .GET_GOODSLIST({
          brandId: brandId || this.brandId,
          isControl: isControl || false,
          ...this.pageInfo
        })
        .then(res => {
          this.loaded = true;
          if (res.status) {
            this.subjectlist = res.data.pageable.data;
            this.total = res.data.pageable.total;
          }
        });
    }
  },
  mounted() {},
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.shoppinglist-container {
  min-height: calc(100vh - 252px);
}
.shopping-title {
  @include flex-d-c;
  align-items: center;
  margin: 40px 0 34px 0;
  h1 {
    font-size: 28px;
    color: #333333;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 18px;
      height: 1px;
      background-color: #e2e2e2;
      line-height: 40px;
      margin-right: 36px;
    }
    &::after {
      content: "";
      display: inline-block;
      width: 18px;
      height: 1px;
      background-color: #e2e2e2;
      line-height: 40px;
      margin-left: 36px;
    }
  }

  p {
    font-size: 12px;
    text-transform: uppercase;
    color: #ccc;
    margin: 0 0 14px;
  }
  i {
    display: block;
    width: 30px;
    height: 4px;
    background-color: #fa4b4b;
  }
}
.list-header {
  display: flex;
  justify-content: space-between;
  margin: 22px 0 24px 0;
}
.title {
  display: flex;
  align-items: center;
  i {
    display: inline-block;
    height: 18px;
    width: 4px;
    background-color: #fa4b4b;
    margin-right: 16px;
  }
}
.listBtn {
  display: flex;
  border-radius: 3px;
  .list,
  .table {
    width: 72px;
    height: 26px;
    @include font(13px, #666666, center, 400, 26px);
    img {
      margin-right: 5px;
    }
  }
  .list {
    border: 1px solid #eeeeee;
    border-radius: 3px 0 0 3px;
  }
  .table {
    border: 1px solid #eeeeee;
    border-radius: 0 3px 3px 0;
    img {
      margin-bottom: -1px;
    }
  }
}
.active {
  color: #f43737 !important;
  border-color: #f43737 !important;
}
.pagination {
  text-align: center;
  padding: 40px 0;
  color: #fa4b4b;
}
.empty {
  height: 260px;
  width: 1200px;
  background-color: #fdfdfd;
  border-radius: 10px;

  @include flex-c;
  .empty-img {
    margin-right: 35px;
  }
  .empty-con {
    @include flex-d-c;
    h5 {
      font-size: 18px;
      color: #505050;
      margin-bottom: 22px;
    }
    p {
      font-size: 16px;
      color: #808080;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/control/index.vue